<template>
	<div>
		<p class="b-payment__header" v-html="loc.SOA_PAYMENT_TITLE"></p>
		<div class="b-payment bx-soa-pp-item-container">
			<div class="b-payment__item"
			     v-for="payment in paymentObj"
			     :key="payment.ID"
			     :class="{'b-payment__item_active' : paymentSelected && payment.CHECKED == 'Y'}"
			>
				<div class="b-payment__company bx-soa-pp-company"
				     @click="selectPayment(payment)">
					<div class="bx-soa-pp-company-graf-container">
						<div class="b-payment__img bx-soa-pp-company-image"
						     v-if="payment.PSA_LOGOTIP">
							<img :src="payment.PSA_LOGOTIP.SRC" :alt="payment.NAME">
						</div>
						<div class="b-payment__img bx-soa-pp-company-image _default"
						     v-else></div>
						<div class="b-payment__title bx-soa-pp-company-title"
						     v-html="payment.NAME"></div>
					</div>
				</div>
			</div>
			<label class="b-payment__error" v-show="hasError" v-html="loc.SOA_PAYMENT_E_REQUIRED"></label>
		</div>
	</div>
</template>

<script>
import {Events, ServerMethod} from "../mixins/constant";
import {Vue} from "ui.vue";

export default {
	name: "PaymentBlock",
	props: {
		paymentObj: {
			type: [Array, Object],
			default: () => {
			}
		},
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("SOA_PAYMENT_");
		},
	},
	data() {
		return {
			paymentSelected: false,
			hasError: false,
		}
	},
	methods: {
		async selectPayment(payment) {
			this.paymentSelected = true;
			await this.checkValid();
			this.$emit("change", payment.ID);
			Vue.event.$emit(Events.REFRESH, {action: ServerMethod.REFRESH, data: {'PAY_SYSTEM_ID': payment.ID}});
		},
		async checkValid() {
			this.hasError = !this.paymentSelected;

			return !this.hasError;
		},
		resetValid: function () {
			this.hasError = false;
		}
	},
}
</script>